module.exports = __webpack_public_path__ + "static/media/small-soldiers3.5bf3121e.gif";